import { installFinalRankApp } from "../rank/finalRankApp";
// 本選ランキング (従来 ApiClient.fetchFinalRanking にハードコードされていたもの) (#630)
import ranking from "../rank/data/final-2025.json";

const main = () => {
  installFinalRankApp({ data: ranking });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", main);
} else {
  main();
}
